import { useTranslation } from 'react-i18next';
import { setLanguage } from '@/i18n';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';

const LanguageSelect = ({ onComplete }) => {
  const { t } = useTranslation();

  const handleSelectLanguage = (lang) => {
    setLanguage(lang);
    if (onComplete) {
      onComplete();
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#08172F] to-[#1a3a6e] p-4">
      <Card className="w-full max-w-md bg-white/95 backdrop-blur-sm shadow-2xl">
        <CardContent className="pt-8 pb-8 px-8">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-gradient-to-r from-[#FFD700] to-[#FFA500] rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">M</span>
              </div>
              <span className="text-xl font-bold text-[#08172F] font-['Montserrat']">MagicStay</span>
            </div>
          </div>

          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-[#08172F]/10 rounded-full flex items-center justify-center">
              <Globe className="w-8 h-8 text-[#08172F]" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-center text-[#08172F] mb-2 font-['Montserrat']">
            {t('languageSelect.title')}
          </h1>

          {/* Subtitle */}
          <p className="text-center text-gray-600 mb-8">
            {t('languageSelect.subtitle')}
          </p>

          {/* Language Buttons */}
          <div className="space-y-4">
            <Button
              variant="outline"
              className="w-full h-14 text-lg justify-start gap-4 border-2 hover:bg-[#08172F] hover:text-white hover:border-[#08172F] transition-all"
              onClick={() => handleSelectLanguage('pt-BR')}
              data-testid="language-select-pt-br"
            >
              <span className="text-2xl">🇧🇷</span>
              <span>{t('languageSelect.ptBR')}</span>
            </Button>

            <Button
              variant="outline"
              className="w-full h-14 text-lg justify-start gap-4 border-2 hover:bg-[#08172F] hover:text-white hover:border-[#08172F] transition-all"
              onClick={() => handleSelectLanguage('en-US')}
              data-testid="language-select-en-us"
            >
              <span className="text-2xl">🇺🇸</span>
              <span>{t('languageSelect.enUS')}</span>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default LanguageSelect;
